import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getyInventorFilterList } from "src/api/bi";
import { resetStore } from "src/store/actions";
import {
  InventoryFilterParamObj,
  InventoryTableInitialState
} from "../interface";
import { handleFullFillForFetchInventoryTableData } from "./InventoryTableReducers";
import { fetchInventoryTableData } from "./InventoryTableAsyncThunks";

const initialState: InventoryTableInitialState = {
  data: null,
  recordsCount: null,
  totalCasesReceived: "-",
  status: "idle",
  error: null,
  inventoryRequestId: null,
  totalUnitsReceived: "-"
};

export const fetchInventoryFilterList = createAsyncThunk(
  "dashboard/filterList",
  (filterParamObj: InventoryFilterParamObj) =>
    getyInventorFilterList(filterParamObj)
);

const inventoryTableData = createSlice({
  name: "inventoryTable",
  initialState,
  reducers: {
    updateData(
      state: InventoryTableInitialState,
      action: { payload: { data: any } }
    ) {
      state.data = action.payload.data;
      state.recordsCount = state?.data?.length || 0;
    }
  },
  extraReducers(builder) {
    builder
      .addCase(resetStore, (state, action) => {
        return initialState;
      })
      .addCase(fetchInventoryTableData.pending, (state, action) => {
        state.status = "pending";
        state.totalUnitsReceived = "-";
        state.totalCasesReceived = "-";
        state.inventoryRequestId = action.meta.requestId;
      })
      .addCase(fetchInventoryTableData.fulfilled, (state, action) => {
        if (action.meta.requestId !== state.inventoryRequestId) {
          return;
        }
        handleFullFillForFetchInventoryTableData(state, action as any);
      })
      .addCase(fetchInventoryTableData.rejected, (state) => {
        state.status = "error";
        state.data = null;
        state.totalUnitsReceived = "-";
        state.totalCasesReceived = "-";
      });
  }
});

export const selectInventoryTableData = ({
  inventoryTable
}: {
  inventoryTable: InventoryTableInitialState;
}) => inventoryTable.data;

export const selectInventoryTableRecordsCount = ({
  inventoryTable
}: {
  inventoryTable: InventoryTableInitialState;
}) => inventoryTable.recordsCount;

export const selectInventoryTableApiStatus = ({
  inventoryTable
}: {
  inventoryTable: InventoryTableInitialState;
}) => inventoryTable.status;

export const selectInventoryTableError = ({
  inventoryTable
}: {
  inventoryTable: InventoryTableInitialState;
}) => inventoryTable.error;

export const { updateData } = inventoryTableData.actions;

export default inventoryTableData.reducer;
